import { render, staticRenderFns } from "./PersonalInfoDialog.vue?vue&type=template&id=fa88c5dc"
import script from "./PersonalInfoDialog.vue?vue&type=script&lang=js"
export * from "./PersonalInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoDialog.vue?vue&type=style&index=0&id=fa88c5dc&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports